import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const archiveBox = document.querySelectorAll(".archive-box");
const archiveOverlay = document.querySelector(".archive-explore-overlay");
const archiveCloseBtn = document.querySelector(".archive-explore-overlay-btn");

window.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollSmoother, ScrollTrigger);

  let smoother = ScrollSmoother.create({
    wrapper: "#smooth-wrapper",
    content: "#smooth-content",
    smooth: 2,
    smoothTouch: 0.1,
  });
});

archiveBox.forEach((box) => {
  box.addEventListener("click", function (e) {
    archiveOverlay.style.display = "block";
  });
});

archiveCloseBtn.addEventListener("click", function (e) {
  archiveOverlay.style.display = "none";
  document.exitFullscreen();
});

/* ARCHIVE-SLIDER */

/** SLIDER */
const LeftClick = document.querySelector(".archive-slides-slider-left");
const RightClick = document.querySelector(".archive-slides-slider-right");
const ArchiveBox = document.querySelectorAll(".archive-box");
const sliderImages = document.querySelectorAll(
  ".archive-slides-slider-container-image"
);

// SLIDER TEXT
const textSliderBoxes = document.querySelectorAll(
  ".archive-slides-slider-text-wrapper"
);

const ArchiveId = function (callback) {
  ArchiveBox.forEach((box) => {
    box.addEventListener("click", function (e) {
      callback(e.target.id);
    });
  });
};

let currentSlide = 0;
const totalSlides = sliderImages.length;

ArchiveId(function (id) {
  currentSlide = id;
  // Inisital slider position
  sliderImages.forEach((image, index) => {
    // image.style.transform = `translateX(${index * 100}%)`;
    image.style.transform = `translateX(${100 * (index - currentSlide)}%)`;
    image.style.transition = `transform 1s ease`;
  });

  // Initial Text Position
  textSliderBoxes.forEach((text, index) => {
    // text.style.transform = `translateX(${index * 100}%)`;
    text.style.transform = `translateX(${100 * (index - currentSlide)}%)`;
    text.style.transition = `transform 1s ease`;
  });
  if (currentSlide === 0) {
    LeftClick.style.visibility = "hidden";
  }
});

LeftClick.addEventListener("click", function (e) {
  console.log("left click");
  if (currentSlide > 0) {
    currentSlide--;
  } else {
    return;
  }

  if (currentSlide === 0) {
    LeftClick.style.visibility = "hidden";
    RightClick.style.visibility = "visible";
  }

  if (currentSlide < totalSlides - 1) {
    RightClick.style.visibility = "visible";
  }

  sliderImages.forEach((image, index) => {
    image.style.transform = `translateX(${100 * (index - currentSlide)}%)`;
    image.style.transition = `transform 1s ease`;
  });

  textSliderBoxes.forEach((text, index) => {
    text.style.transform = `translateX(${100 * (index - currentSlide)}%)`;
    text.style.transition = `transform 1s ease`;
  });
});

RightClick.addEventListener("click", function (e) {
  console.log("right click");
  if (currentSlide < totalSlides - 1) {
    currentSlide++;
  } else {
    return;
  }

  if (currentSlide > 0) {
    LeftClick.style.visibility = "visible";
  }

  if (currentSlide === totalSlides - 1) {
    RightClick.style.visibility = "hidden";
  }

  sliderImages.forEach((image, index) => {
    image.style.transform = `translateX(${100 * (index - currentSlide)}%)`;
    image.style.transition = `transform 1s ease`;
  });

  textSliderBoxes.forEach((text, index) => {
    text.style.transform = `translateX(${100 * (index - currentSlide)}%)`;
    text.style.transition = `transform 1s ease`;
  });
});

/** FULL SCREEN */
const fullScreenOpenBtn = document.querySelector(
  ".archive-explore-fullscreen-open-btn"
);

const ArchiveFullScreen = document.querySelector(".archive-slides-box");
const ArchiveFullscreenTwo = document.querySelector(
  ".archive-slides-slider-text-container"
);
const ArchiveFullScreenBtnBox = document.querySelector(
  ".archive-explore-fullscreen-open-btn"
);
const ArchiveFullScreenCloseBtn = document.querySelector(
  ".archive-explore-fullscreen-close-btn"
);

function getFullScreenElement() {
  return document.fullscreenElement;
}

function fullScreenChangeUi() {
  if (getFullScreenElement()) {
    console.log("Fullscreen ON - Element is in fullscreen mode");
    ArchiveFullScreen.classList.add("archive-slide-box-column");
    ArchiveFullscreenTwo.classList.add("archive-slide-text-contianer-remove");
    ArchiveFullScreenBtnBox.classList.add(
      "archive-explore-fullscreen-open-btn-display-off"
    );
    ArchiveFullScreenCloseBtn.classList.add(
      "archive-explore-fullscreen-close-btn-on"
    );
  } else {
    console.log("Fullscreen OFF - Element is NOT in fullscreen mode");
    ArchiveFullScreen.classList.remove("archive-slide-box-column");
    ArchiveFullscreenTwo.classList.remove(
      "archive-slide-text-contianer-remove"
    );
    ArchiveFullScreenBtnBox.classList.remove(
      "archive-explore-fullscreen-open-btn-display-off"
    );
    ArchiveFullScreenCloseBtn.classList.remove(
      "archive-explore-fullscreen-close-btn-on"
    );
  }
}

ArchiveFullScreenCloseBtn.addEventListener("click", function (e) {
  document.exitFullscreen();
});

document.addEventListener("fullscreenchange", fullScreenChangeUi);

fullScreenOpenBtn.addEventListener("click", function (e) {
  document.documentElement.requestFullscreen().catch((e) => {
    console.log(e);
  });
});
